module.exports = __webpack_public_path__ + "img/PCDarkMode.dd7b1cb1.png";